import { cx } from "@linaria/core";
import { useResizeObserverEntry } from "timvir/hooks";
import * as React from "react";
import { Canvas } from "./internal";
import { Descriptor } from "./types";

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
interface Props extends React.ComponentProps<typeof Root> {
  descriptor: Descriptor;
}
const classes = {
  name: "n1xsexuc"
};
function Icon(props: Props, ref: React.ForwardedRef<React.ElementRef<typeof Root>>) {
  const {
    descriptor,
    className,
    ...rest
  } = props;
  const [roRef, roe] = useResizeObserverEntry();
  const width = roe?.contentRect.width;
  return <Root ref={ref} className={cx(className, "r1k0w618")} {...rest}>
      <div ref={roRef}>
        {width !== undefined && <>
            <Canvas width={width} height={width} size={32 /*descriptor.instances[0].size as number */} Component={descriptor.instances[0].Component} />
            <div className={classes.name}>{descriptor.name}</div>
          </>}
      </div>
    </Root>;
}
export default React.forwardRef(Icon);

require("./Icon.linaria.module.css!=!../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Icon.tsx");